import { parseFasta } from './validation';
import { ISequenceInputValue } from '../types';

export function getInitialSequenceInputValue(config?: Record<string, any>, prefilledInput?: string): ISequenceInputValue {
    const initialRows: Record<number, Record<number, string>> = {};
    
    for (let i = 0; i < 100; i += 1) {
        initialRows[i] = { 0: '', 1: '' };
    }
    
    if (prefilledInput) {
        try {
            if (prefilledInput.includes('>')) {
                const records = parseFasta(prefilledInput, config);
                
                for (let i = 0; i < records.length; i += 1) {
                    const record = records[i];
                    initialRows[i] = { 0: record.sequenceId, 1: record.sequence };
                }
            } else {
                initialRows[0] = { 0: '', 1: prefilledInput.trim() };
            }
        } catch (error) {
            console.error('Failed to parse prefilled input as FASTA. Got error: ', error);
            initialRows[0] = { 0: '', 1: prefilledInput };
        }
    }
    
    return {
        filename: null,
        rows: initialRows
    };
}
